import {Component, inject, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';

import { TabViewModule } from 'primeng/tabview';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { DependenciasUsuarioComponent } from './dependencias-usuario/dependencias-usuario.component';
import { TranslateModule } from '@ngx-translate/core';
import {CustomTitleDirective} from "../../../shared/clases/custom-title.directive";

@Component({
  selector: 'app-admin-usuarios',
  standalone: true,
  imports: [CommonModule, TabViewModule, TranslateModule,
    UsuariosComponent, DependenciasUsuarioComponent
  ],
  templateUrl: './admin-usuarios.component.html',
  styleUrls: ['../../../../assets/styles/style.mantenimiento.scss']
})
export class AdminUsuariosComponent {
  activeTabIndex: number = 0;
  private titleService:CustomTitleDirective = inject(CustomTitleDirective);

  @ViewChild(UsuariosComponent) UsuariosComponent !: UsuariosComponent;
  @ViewChild(DependenciasUsuarioComponent) dependenciasUsuarioComponent !: DependenciasUsuarioComponent;

  constructor() { }

  activeIndexChange(index: number) {
    if (index === 0) {
      this.UsuariosComponent.initializePage();
      this.titleService.changeTitle('components.app-admin-usuarios.usuarios');
    } else {
      this.dependenciasUsuarioComponent.getDependencias();
      this.titleService.changeTitle('components.app-admin-usuarios.dependencias');
    }
  }
}

